<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import location from './Indow-Location-Portland-Map.png';

	let { backgroundColor = 'blue' } = $props();
</script>

<Section {backgroundColor}>
	<h2>Our Location</h2>
	<div
		class="
    flex w-full flex-col justify-center gap-5
    md:flex-row
    md:[&_p]:place-self-start
  "
	>
		<div
			class="
     grid w-full gap-4 place-self-start
     md:w-auto
   "
		>
			<a
				href="https://maps.app.goo.gl/wWtVhB93DPYhrUhCA"
				target="_blank"
				rel="noopener noreferrer"
				class=""
			>
				<Image
					src={location}
					alt="Map showing Indow factory location in portland."
					class="
       aspect-square max-w-48 rounded-full border-4 border-solid
       border-indow-white
     "
				/>
			</a>
			<p class="mb-0">
				<a
					href="https://maps.app.goo.gl/wWtVhB93DPYhrUhCA"
					target="_blank"
					rel="noopener noreferrer"
				>
					Click for a larger map
				</a>
			</p>
		</div>

		<div
			class="
     max-w-prose border-solid border-indow-white
     max-md:border-t-2 max-md:pt-5
     md:border-l-2 md:pl-4
   "
		>
			<p class="mb-4 text-left">
				We are a Portland-based company serving the U.S. and Canada
			</p>
			<ul class="grid list-none grid-cols-[auto_1fr] gap-4">
				<li class="col-span-full grid grid-cols-subgrid">
					<p
						class="
        col-start-1 mb-0 font-bold
        max-xs:col-span-full
      "
					>
						Email:
					</p>
					<p
						class="
        col-start-2 mb-0
        max-xs:col-span-full
      "
					>
						<a href="mailto:opportunity@indowwindows.com" class="break-all"
							>opportunity@indowwindows.com</a
						>
					</p>
				</li>
				<li class="col-span-full grid grid-cols-subgrid">
					<p
						class="
        col-start-1 mb-0 font-bold
        max-xs:col-span-full
      "
					>
						Call:
					</p>
					<p
						class="
        col-start-2 mb-0
        max-xs:col-span-full
      "
					>
						<a href="tel:(503) 284-2260" class="break-all">(503) 284-2260</a>
					</p>
				</li>

				<li class="col-span-full grid grid-cols-subgrid">
					<p class="col-span-full mb-2 text-left font-bold">
						Send us a letter:
					</p>
					<p
						class="
        col-start-2 mb-2 text-left
        max-xs:col-span-full
      "
					>
						<a
							href="https://maps.app.goo.gl/wWtVhB93DPYhrUhCA"
							target="_blank"
							rel="noreferrer"
							>6427 NE 59th Place<br />
							Portland, OR 97218</a
						>
					</p>
					<p class="col-span-full col-start-1 text-left">
						(visits to our facility are by appointment only)
					</p>
				</li>
			</ul>
		</div>
	</div>
</Section>
